<script>

import {defineComponent} from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import axios from "axios";
import {ImagesPath, PackagingPath} from "@/path";
import Swal from "sweetalert2";

export default defineComponent({
  props : ['selectedPackaging'],
  components: {SelectWithSearch},
  data(){
    return {
      cdn : process.env.VUE_APP_AWS_CDN,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      form : {
        images : []
      }
    }
  },
  watch : {
    selectedPackaging(v){
      this.form = v;
    }
  },
  mounted(){
    if(this.selectedPackaging){
      this.form = this.selectedPackaging;
    }
  },
  methods : {
    async saveImage(e,imk){
      try {
        let formData = new FormData();
        formData.append('file',e.target.files[0]);
        formData.append('folder','items');
        let res = await axios.post(this.baseUrl + ImagesPath.UPLOAD_IMAGE,formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(res.data.status){
          this.form.images[imk].img_url = res.data.data.file;
        }
      }catch (err){
        console.log(err);
      }
    },
    async savePackaging(){
      try {
        let res = await axios.post(this.baseUrl + PackagingPath.ALL,this.form);
        if(res.data.status){
          Swal.fire("success",'','success');
          this.$bvModal.hide('bv-add-packaging')
          this.$emit('update');
        }
      }catch (e){
        console.log(e);
      }
    },
    async deleteImage(v){
      try{
        console.log(v);
        this.form.images.splice(v,1);
      }catch (e){
        console.log(e);
      }
    }
  }
})
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col class="mt-3" sm="12">
          <label>Name</label>
          <b-form-input size="sm" v-model="form.name"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Specifications</label>
          <b-form-textarea size="sm" v-model="form.specifications"></b-form-textarea>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Description</label>
          <b-form-textarea size="sm" v-model="form.description"></b-form-textarea>
        </b-col>
        <b-col class="mt-3" sm="4">
          <label>Selling price</label>
          <b-form-input size="sm" v-model="form.selling_price"></b-form-input>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Images</label>
          <template>
            <b-button class="ml-2" size="sm" @click="(() => form.images.push({img_url : ''}))"><i class="fa fa-plus-square"></i></b-button>
            <b-row v-for="(im,imk) in form.images" :key="imk">
              <b-col sm="8">
                <b-img v-if="im.img_url != ''" height="60" :src="cdn + '/' + im.img_url"></b-img>
                <b-form-file v-if="im.img_url == ''" accept="image/*" @change="saveImage($event,imk)"></b-form-file>
              </b-col>
              <b-col sm="4">
                <b-button size="sm"><i class="fa fa-trash" @click="deleteImage(imk)"></i></b-button>
              </b-col>
            </b-row>
          </template>
        </b-col>
        <b-col class="mt-3" size="sm">
          <b-button @click="savePackaging" variant="primary">Save</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>

</style>